/* 🤖 this file was generated by svg-to-ts */
export const emperorIconHide: {
  name: 'hide';
  data: string;
} = {
  name: 'hide',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M18.49 7.715L22.69 3.5l-1.42-1.42 -19.48 19.46 1.41 1.41 5.16-5.17c1.11.42 2.31.69 3.59.69 6.35 0 11-6.5 11-6.5s-1.73-2.4-4.51-4.29ZM11.99 16c-.53 0-1.04-.11-1.5-.3l5.19-5.198c.18.46.29.96.29 1.49 0 2.21-1.8 4-4 4Z"/><path d="M4.785 15.77l3.26-3.27c-.03-.17-.05-.34-.05-.51 0-2.21 1.79-4 4-4 .17 0 .34.02.51.04l2.15-2.16c-.85-.25-1.734-.391-2.67-.391 -6.352 0-11 6.5-11 6.5s1.43 1.99 3.785 3.77Z"/></g></svg>`
};
